// extracted by mini-css-extract-plugin
export default {"root":"_2M_1Ol43","disabled":"_39IPMV52","label":"v3GxyvsU","soon":"_2ovZTsiT","icon":"RtpShIgh","badge":"_26y6czIF","arrow":"rtv2K6C8","chevronData":"_2EfGiufa"};